import './comment.css';

// Define Comment and UserInfo types consistent with their usage
interface CommentData {
  id: string;
  content: string;
  userId: string; // Assuming string based on previous fixes
  createdAt: string;
}

interface UserInfo {
  id: number;
  name: string;
  username: string;
}

interface CommentProps {
  comment: CommentData;
  userInfo?: UserInfo; // Pass the specific user info, or undefined
}

// Utility function moved here
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return (
    date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }) +
    ' ' +
    date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
    })
  );
};

export const Comment = ({ comment, userInfo }: CommentProps) => {
  let userName = 'Unknown User'; // Default to Unknown
  if (userInfo) {
    userName = userInfo.name;
  } else if (comment.userId) {
    // If userInfo is not yet loaded but we have a userId, show loading
    userName = 'Loading user...';
  }

  return (
    <div key={comment.id} className="comment">
      <div className="comment-author">{userName}</div>
      <div className="comment-date">{formatDate(comment.createdAt)}</div>

      <div className="comment-content">{comment.content}</div>
    </div>
  );
};
